module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Eigene Rechnungen")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Rechnungsnummer")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Summe")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Zahlbar bis")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rechnungen), function(item) {
    return _c('tr', {
      key: item.name,
      on: {
        "dblclick": function($event) {
          return _vm.goToId(item.id)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.rechnungsnummer))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.summe)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.$filters.date(item.rechnung_zahlbar_bis, "DD.MM.YYYY")))])])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13f60d8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module_klein/rechnungenEigene.vue
// module id = 737
// module chunks = 15